(function () {
  var popstateBound = false;

  var renderToken = 0;

  var FULL_FILTERS = ['price', 'color', 'colour', 'brand', 'vendor', 'availability'];

  var COLOR_WORDS = [
    ['chartreuse', '#b5c73a'], ['lavender', '#b7a0d4'], ['turquoise', '#3aa8a0'], ['chocolate', '#5c3317'],
    ['burgundy', '#6e2432'], ['charcoal', '#3d3d3d'], ['magenta', '#c43d7a'], ['crimson', '#a4161a'],
    ['marigold', '#e2a322'], ['mustard', '#d4a017'], ['apricot', '#f0b27a'], ['birchwood', '#c4a882'],
    ['eggplant', '#614051'], ['amethyst', '#9966cc'], ['sapphire', '#0f52ba'], ['emerald', '#2f6b4f'],
    ['copper', '#b87333'], ['salmon', '#e9967a'], ['indigo', '#3f2d78'], ['violet', '#6b3fa0'],
    ['purple', '#5c2d91'], ['lilac', '#b497c6'], ['maroon', '#7a2f3b'], ['cobalt', '#2b4c9a'],
    ['denim', '#3d5a80'], ['navy', '#1e3a5f'], ['teal', '#1a8a84'], ['aqua', '#5ec8c8'],
    ['mint', '#9dcec0'], ['sage', '#8aa88a'], ['olive', '#6b7040'], ['forest', '#2f4f3a'],
    ['moss', '#6d8a62'], ['lime', '#8fbf3f'], ['pink', '#e8a0b0'], ['rose', '#d4738a'],
    ['blush', '#e7b7c3'], ['coral', '#e07a5f'], ['peach', '#f3c1a0'], ['orange', '#f08a24'],
    ['amber', '#e0a106'], ['gold', '#c99a3e'], ['yellow', '#f2d031'], ['lemon', '#f4e04d'],
    ['cream', '#f3ead7'], ['ivory', '#f4efe4'], ['beige', '#e6d5b8'], ['khaki', '#c3b091'],
    ['camel', '#c19a6b'], ['brown', '#8a5a3b'], ['coffee', '#6f4e37'], ['rust', '#a24b2d'],
    ['wine', '#722f37'], ['plum', '#7a3e6d'], ['blue', '#3d6fbf'], ['sky', '#87b7e0'],
    ['green', '#3d8c5a'], ['grey', '#9a9a9a'], ['gray', '#9a9a9a'], ['silver', '#c0c0c0'],
    ['black', '#2b2b2b'], ['white', '#f7f4ef'], ['red', '#c44536'], ['tan', '#c4a574'],
    ['birch', '#d7c4a3'], ['linen', '#e6dcc8'], ['oatmeal', '#e4d5b7'], ['natural', '#efe6d6'],
    ['sand', '#e7d3b0'], ['taupe', '#b5a48a'], ['slate', '#708090'], ['pewter', '#8e8e93'],
    ['fog', '#c5c9c7'], ['mist', '#d5dbd8'], ['lichen', '#9aaa84'], ['fern', '#4f7942'],
    ['pine', '#2f5d50'], ['ocean', '#2e6f8e'], ['sea', '#3d8ea8'], ['lagoon', '#3aa6a0'],
    ['fuchsia', '#c74375'], ['raspberry', '#b03060'], ['berry', '#8e3a59'], ['cherry', '#a33b3b'],
    ['brick', '#a0522d'], ['terracotta', '#c46b4a'], ['clay', '#b86b4a'], ['honey', '#e2b657'],
    ['butter', '#f3e3a1'], ['maize', '#f2c14e'], ['sunshine', '#f0c84b'], ['canary', '#f4e04d'],
    ['periwinkle', '#8e99d4'], ['cornflower', '#6d8fd4'], ['royal', '#2f4fa3'], ['azure', '#3d7ec9'],
    ['cyan', '#3aabb8'], ['jade', '#3d8b74'], ['kelly', '#3c9a4e'], ['hunter', '#355e3b'],
    ['avocado', '#7d8f4e'], ['pistachio', '#b7c99a'], ['spearmint', '#7dcea0'], ['eucalyptus', '#8fafa0'],
    ['heather', '#b7b1c2'], ['ash', '#b2b2b2'], ['graphite', '#4a4a4a'], ['ebony', '#2a2a2a'],
    ['ink', '#1c2838'], ['midnight', '#1b2430'], ['storm', '#6d7580'], ['cloud', '#e7eceb'],
    ['snow', '#f7f7f5'], ['pearl', '#f3efe6'], ['bone', '#e7ddcc'], ['wheat', '#e3c98a'],
    ['caramel', '#c68642'], ['cocoa', '#6b4226'], ['mocha', '#7b5b3a'], ['espresso', '#4b3426'],
    ['mahogany', '#6e3b2e'], ['chestnut', '#8b4e34'], ['walnut', '#6b4a32'], ['wood', '#a67c52'],
    ['blush', '#e7b7c3']
  ];

  function colorFromName(name) {
    var normalized = String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    var padded = ' ' + normalized + ' ';
    var match = '';
    var matchLength = 0;

    COLOR_WORDS.forEach(function (pair) {
      var word = pair[0];
      var found = padded.indexOf(' ' + word + ' ') !== -1 || (word.length >= 4 && normalized.indexOf(word) !== -1);
      if (found && word.length > matchLength) {
        match = pair[1];
        matchLength = word.length;
      }
    });

    if (match) return match;

    var hash = 0;
    var key = normalized || 'swatch';
    for (var i = 0; i < key.length; i++) hash = ((hash * 33) + key.charCodeAt(i)) >>> 0;
    return 'hsl(' + (hash % 360) + ', 46%, 48%)';
  }

  function paintSwatches(root) {
    root.querySelectorAll('.ccg-swatch').forEach(function (swatch) {
      var dot = swatch.querySelector('.ccg-swatch__dot');
      if (!dot) return;
      var given = dot.getAttribute('data-swatch-color') || '';
      var usable = given && given.indexOf('url(') === -1 && given.indexOf('http') === -1 && given.indexOf('/') === -1;
      var color = usable ? given : colorFromName(swatch.getAttribute('data-swatch-name') || swatch.getAttribute('title') || '');
      dot.style.setProperty('background-image', 'none', 'important');
      dot.style.setProperty('background-color', color, 'important');
    });
  }

  function limitFilterLists(root) {
    root.querySelectorAll('.ccg-filter').forEach(function (filter) {
      var summary = filter.querySelector('.ccg-filter__summary');
      var label = summary ? summary.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (FULL_FILTERS.indexOf(label) !== -1) return;

      var list = filter.querySelector('.ccg-options');
      if (!list || list.dataset.ccgLimited === 'true') return;
      var items = Array.prototype.slice.call(list.children).filter(function (item) {
        return item.tagName === 'LI';
      });
      if (items.length <= 5) return;

      list.dataset.ccgLimited = 'true';
      list.classList.add('is-collapsed');
      items.forEach(function (item, index) {
        if (index < 5) return;
        item.classList.add('ccg-option-extra');
        item.hidden = true;
      });

      if (!filter.querySelector('[data-ccg-show-more]')) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ccg-show-more';
        button.setAttribute('data-ccg-show-more', '');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = 'Show more';
        list.insertAdjacentElement('afterend', button);
      }
    });
  }

  function preparePrices(form) {
    if (!form) return;
    form.querySelectorAll('[data-ccg-price]').forEach(function (wrap) {
      var minInput = wrap.querySelector('[data-input="min"]');
      var maxInput = wrap.querySelector('[data-input="max"]');
      var minRange = wrap.querySelector('[data-range="min"]');
      var maxRange = wrap.querySelector('[data-range="max"]');
      if (!minInput || !maxInput || !minRange || !maxRange) return;

      var floor = Number(minRange.min || 0);
      var ceiling = Number(maxRange.max);
      var minVal = Number(minInput.value);
      var maxVal = Number(maxInput.value);
      if (Number.isNaN(minVal)) minVal = floor;
      if (Number.isNaN(maxVal)) maxVal = ceiling;
      if (minVal < floor) minVal = floor;
      if (maxVal > ceiling) maxVal = ceiling;
      if (minVal > maxVal) minVal = maxVal;

      minInput.value = String(minVal);
      maxInput.value = String(maxVal);
      minRange.value = String(minVal);
      maxRange.value = String(maxVal);

      var atFullRange = minVal <= floor && maxVal >= ceiling;
      if (atFullRange) {
        minInput.removeAttribute('name');
        maxInput.removeAttribute('name');
      } else {
        minInput.name = minInput.dataset.param;
        maxInput.name = maxInput.dataset.param;
      }
    });
  }

  function sectionUrl(root, href) {
    var url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', root.dataset.sectionId);
    url.searchParams.delete('page');
    return url;
  }

  function displayUrl(href) {
    var url = new URL(href, window.location.origin);
    url.searchParams.delete('section_id');
    return url.pathname + url.search;
  }

  var reopenDrawer = false;
  var drawerScrollTop = 0;
  var pageScrollTop = 0;

  function setDrawer(sidebar, open) {
    if (!sidebar) return;
    var root = sidebar.closest('[data-ccg-root]');
    var toggle = root && root.querySelector('[data-ccg-toggle]');
    var mobile = window.matchMedia('(max-width: 989px)').matches;
    sidebar.classList.toggle('is-open', open && mobile);
    if (toggle) toggle.setAttribute('aria-expanded', open && mobile ? 'true' : 'false');
    var panel = sidebar.querySelector('.ccg-sidebar__panel');
    if (panel) panel.setAttribute('aria-modal', open && mobile ? 'true' : 'false');
    document.documentElement.classList.toggle('ccg-drawer-open', open && mobile);
  }

  function restorePlace(sidebar) {
    var scroller = sidebar && sidebar.querySelector('.ccg-filters');
    if (scroller) scroller.scrollTop = drawerScrollTop;
    window.scrollTo(0, pageScrollTop);
  }

  function renderSection(root, href, push) {
    if (!root || !href) return;
    var sidebar = root.querySelector('[data-ccg-sidebar]');
    var scroller = root.querySelector('.ccg-sidebar__panel .ccg-filters');
    reopenDrawer = !!(sidebar && sidebar.classList.contains('is-open'));
    drawerScrollTop = scroller ? scroller.scrollTop : 0;
    pageScrollTop = window.scrollY || window.pageYOffset || 0;

    var token = ++renderToken;
    var requestUrl = sectionUrl(root, href);
    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');

    fetch(requestUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        if (token !== renderToken) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-ccg-root]');
        var host = document.body.contains(root) ? root : document.querySelector('[data-ccg-root]');
        if (!next || !host) {
          window.location.assign(displayUrl(href));
          return;
        }

        next.classList.remove('is-loading');
        next.removeAttribute('aria-busy');
        host.replaceWith(next);
        init(next);

        if (push) {
          history.pushState({ ccg: true }, '', displayUrl(href));
        }

        restorePlace(next.querySelector('[data-ccg-sidebar]'));
        requestAnimationFrame(function () {
          restorePlace(document.querySelector('[data-ccg-sidebar]'));
        });
      })
      .catch(function () {
        if (token !== renderToken) return;
        root.classList.remove('is-loading');
        root.removeAttribute('aria-busy');
      });
  }

  function init(root) {
    if (!root || root.dataset.ccgInit === 'true') return;
    root.dataset.ccgInit = 'true';
    paintSwatches(root);
    limitFilterLists(root);

    var form = root.querySelector('[data-ccg-form]');
    var sidebar = root.querySelector('[data-ccg-sidebar]');
    var toggle = root.querySelector('[data-ccg-toggle]');
    var moreBtn = root.querySelector('[data-ccg-more]');
    var grid = root.querySelector('[data-ccg-grid]');
    var status = root.querySelector('[data-ccg-status]');

    if (toggle && sidebar) {
      toggle.addEventListener('click', function () {
        var willOpen = !sidebar.classList.contains('is-open');
        setDrawer(sidebar, willOpen);
        if (willOpen) {
          var closeBtn = sidebar.querySelector('[data-ccg-close]');
          if (closeBtn && closeBtn.focus) closeBtn.focus({ preventScroll: true });
        }
      });
      sidebar.addEventListener('click', function (event) {
        if (event.target.closest('[data-ccg-close], [data-ccg-backdrop]')) {
          setDrawer(sidebar, false);
        }
      });
      if (reopenDrawer) {
        setDrawer(sidebar, true);
        restorePlace(sidebar);
      }
    }
    reopenDrawer = false;

    var priceTimer = null;

    function applyFilters() {
      if (!form) return;
      preparePrices(form);
      var params = new URLSearchParams(new FormData(form));
      var url = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
      url.search = params.toString();
      renderSection(root, url.toString(), true);
    }

    function applyPriceFilters() {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(applyFilters, 120);
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        applyFilters();
      });

      var sort = root.querySelector('[data-ccg-sort]');
      if (sort) sort.addEventListener('change', applyFilters);

      form.addEventListener('change', function (event) {
        if (event.target.matches('input[type="checkbox"]')) applyFilters();
      });

      form.querySelectorAll('[data-ccg-price]').forEach(function (wrap) {
        var minRange = wrap.querySelector('[data-range="min"]');
        var maxRange = wrap.querySelector('[data-range="max"]');
        var minInput = wrap.querySelector('[data-input="min"]');
        var maxInput = wrap.querySelector('[data-input="max"]');
        if (!minRange || !maxRange || !minInput || !maxInput) return;

        function sync(source) {
          var min = Number(minRange.value);
          var max = Number(maxRange.value);
          if (min > max) {
            if (source === 'min') minRange.value = String(max);
            else maxRange.value = String(min);
          }
          minInput.value = minRange.value;
          maxInput.value = maxRange.value;
        }

        minRange.addEventListener('input', function () { sync('min'); });
        maxRange.addEventListener('input', function () { sync('max'); });
        minRange.addEventListener('change', applyPriceFilters);
        maxRange.addEventListener('change', applyPriceFilters);

        minInput.addEventListener('change', function () {
          minRange.value = minInput.value || minRange.min || '0';
          sync('min');
          applyPriceFilters();
        });
        maxInput.addEventListener('change', function () {
          maxRange.value = maxInput.value || maxRange.max;
          sync('max');
          applyPriceFilters();
        });
      });
    }

    root.addEventListener('click', function (event) {
      var moreToggle = event.target.closest('[data-ccg-show-more]');
      if (moreToggle) {
        event.preventDefault();
        var list = moreToggle.parentElement.querySelector('.ccg-options');
        if (!list) return;
        var collapsed = list.classList.toggle('is-collapsed');
        list.querySelectorAll('.ccg-option-extra').forEach(function (item) {
          item.hidden = collapsed;
        });
        moreToggle.textContent = collapsed ? 'Show more' : 'Show less';
        moreToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        return;
      }

      var link = event.target.closest('a.ccg-chip, a.ccg-clear');
      if (!link) return;
      event.preventDefault();
      renderSection(root, link.href, true);
    });

    if (moreBtn && grid) {
      moreBtn.addEventListener('click', function () {
        var nextUrl = moreBtn.getAttribute('data-url');
        if (!nextUrl || moreBtn.disabled) return;

        moreBtn.disabled = true;
        var previous = moreBtn.textContent;
        moreBtn.textContent = 'Loading…';

        var url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', root.dataset.sectionId);

        fetch(url.toString())
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('[data-ccg-grid]');
            if (nextGrid) {
              nextGrid.querySelectorAll('.ypc-card').forEach(function (card) {
                grid.appendChild(card);
              });
            }

            var nextStatus = doc.querySelector('[data-ccg-status]');
            if (status && nextStatus) status.textContent = nextStatus.textContent;

            var nextMore = doc.querySelector('[data-ccg-more]');
            if (nextMore && nextMore.getAttribute('data-url')) {
              moreBtn.setAttribute('data-url', nextMore.getAttribute('data-url'));
              moreBtn.disabled = false;
              moreBtn.textContent = previous;
            } else {
              moreBtn.hidden = true;
            }

            var pageUrl = new URL(nextUrl, window.location.origin);
            pageUrl.searchParams.delete('section_id');
            history.replaceState({ ccg: true }, '', pageUrl.pathname + pageUrl.search);
          })
          .catch(function () {
            moreBtn.disabled = false;
            moreBtn.textContent = previous;
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ccg-root]').forEach(init);
  }

  if (!popstateBound) {
    popstateBound = true;
    window.addEventListener('popstate', function () {
      var current = document.querySelector('[data-ccg-root]');
      if (current) renderSection(current, window.location.href, false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openSidebar = document.querySelector('[data-ccg-sidebar].is-open');
      if (openSidebar) setDrawer(openSidebar, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ccg-root]') || (event.target.matches('[data-ccg-root]') ? event.target : null);
    if (root) init(root);
  });
})();
